<div class="content-block {{ classList }}" [class.block-loader]="isLoading">
	<div class="content-block-header" *ngIf="showHeader">
		<h2 class="content-block-title">
			{{ count ? title + ' (' + (count | mask : 'separator.2') + ')' : title }}
		</h2>

		<ng-content select="[commentTitle]"></ng-content>
		<div class="content-block-actions" *ngIf="!!headerActions">
			<ng-template [ngTemplateOutlet]="headerActions"></ng-template>
		</div>
	</div>

	<ng-content> </ng-content>
</div>
